<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #FAF5F2;">
      <v-flex>
        <!-- Nevigater -->
        <v-layout mb-12>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.push('/post-approve')"
          >
            <span>Post Approve</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="viewData"
          >
            <span>ดูข้อมูล</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3E7662;font-weight: bold;font-size: 24px;"
          >
            <span>รายงานความก้าวหน้าและขอต่ออายุโครงการวิจัย</span>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex>
            <v-layout mt-3 style="background-color: #3E7662;">
              <v-flex
                my-8
                ml-8
                style="text-align: left;font-size: 28px;color: white"
                @click="setData"
              >
                <div style="font-weight: bold">
                  รายงานความก้าวหน้าและขอต่ออายุโครงการวิจัย
                </div>
                <div style="font-size: 18px;">Progress Report Form</div>
              </v-flex>
              <v-flex
                ml-8
                pt-8
                pr-8
                style="text-align: right;font-weight: bold;font-size: 13px;color: white"
              >
                <span>RF 03_2562</span>
              </v-flex>
            </v-layout>

            <!-- blog 1 -->
            <v-card class="mb-12 px-12">
              <v-layout py-12 pr-12 mr-12>
                <v-flex>
                  <!-- row 1 -->
                  <v-layout pt-8 pb-6>
                    <v-flex
                      xs2
                      mr-4
                      d-flex
                      align-center
                      justify-end
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>รหัสโครงร่างการวิจัย</span>
                    </v-flex>
                    <v-flex d-flex align-center xs4>
                      <textfield-form
                        hide-detail
                        :model="form.researchCode"
                        @update-data="updateData('researchCode', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                  <!-- row 2 -->
                  <v-layout pb-6>
                    <v-flex
                      xs2
                      mr-4
                      d-flex
                      align-center
                      justify-end
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>ชื่อผู้วิจัยหลัก</span>
                    </v-flex>
                    <v-flex d-flex align-center xs4>
                      <textfield-form
                        hide-detail
                        :model="form.firstName"
                        @update-data="updateData('firstName', $event)"
                      ></textfield-form>
                    </v-flex>
                    <v-flex
                      xs2
                      pr-4
                      d-flex
                      align-center
                      justify-end
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>นามสกุล</span>
                    </v-flex>
                    <v-flex d-flex align-center xs4>
                      <textfield-form
                        hide-detail
                        :model="form.lastName"
                        @update-data="updateData('lastName', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                  <!-- row 3 -->
                  <v-layout pb-6>
                    <v-flex
                      d-flex
                      align-center
                      xs2
                      mr-4
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>ชื่อโครงการวิจัย (ไทย)</span>
                    </v-flex>
                    <v-flex xs10>
                      <textarea-form
                        hide-detail
                        :model="form.researchName"
                        @update-data="updateData('researchName', $event)"
                      ></textarea-form>
                    </v-flex>
                  </v-layout>
                  <!-- row 4 -->
                  <v-layout pb-6>
                    <v-flex
                      xs2
                      mr-4
                      d-flex
                      align-center
                      justify-end
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>วันที่รับรองครั้งสุดท้าย</span>
                    </v-flex>
                    <v-flex xs3>
                      <DateInputForm
                        hide-detail
                        :model="lastDay"
                        @update-data="updateDate('lastDay', $event)"
                      ></DateInputForm>
                    </v-flex>
                  </v-layout>
                  <!-- row 5 -->
                  <v-layout pb-6>
                    <v-flex
                      xs2
                      mr-4
                      d-flex
                      align-center
                      justify-end
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>วันที่เริ่มเก็บข้อมูล</span>
                    </v-flex>
                    <v-flex xs3>
                      <DateInputForm
                        hide-detail
                        :model="startDay"
                        @update-data="updateDate('startDay', $event)"
                      ></DateInputForm>
                    </v-flex>
                  </v-layout>
                  <!-- row 6 -->
                  <v-layout pb-6>
                    <v-flex
                      xs2
                      mr-4
                      d-flex
                      align-center
                      justify-end
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>วันสิ้นสุดอายุการรับรอง</span>
                    </v-flex>
                    <v-flex xs3>
                      <DateInputForm
                        hide-detail
                        :model="endDay"
                        @update-data="updateDate('endDay', $event)"
                      ></DateInputForm>
                    </v-flex>
                  </v-layout>
                  <!-- row 7 -->
                  <v-layout pb-6>
                    <v-flex
                      xs2
                      mr-4
                      d-flex
                      align-center
                      justify-end
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>วันที่ส่งรายงานความก้าวหน้า</span>
                    </v-flex>
                    <v-flex d-flex align-center xs3>
                      <DateInputForm
                        hide-detail
                        :model="reportDate"
                        @update-data="updateDate('reportDate', $event)"
                      ></DateInputForm>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- blog 2 -->
            <v-layout pt-12 pb-4 mt-12 style="background-color: white;">
              <v-flex>
                <!-- row 1 -->
                <v-layout style="padding-left: 100px;">
                  <v-flex justify-start d-flex>
                    <span style="font-weight: bold;;font-size: 16px;"
                      >เวลาการส่งรายงาน</span
                    >
                  </v-flex>
                </v-layout>
                <v-layout style="padding-left: 30vh;">
                  <v-flex justify-start d-flex>
                    <v-radio-group v-model="form.reportTime" hide-details>
                      <!--<v-radio color="#3E7662" style="padding-right: 100px" label="มากกว่า 30 วัน ก่อนหมดอายุการรับรอง" value="1"></v-radio>-->
                      <v-radio
                        color="#3E7662"
                        style="padding-right: 100px"
                        label="ภายใน 30 วัน ก่อนหมดอายุการรับรอง"
                        value="1"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        style="padding-right: 100px"
                        label="ภายหลังหมดอายุการรับรอง"
                        value="2"
                      ></v-radio>
                      <!--<v-radio color="#3E7662" style="padding-right: 100px" label="ภายหลังหมดอายุการรับรอง" value="4"></v-radio>-->
                    </v-radio-group>
                  </v-flex>
                </v-layout>
                <v-layout style="padding-left: 34vh;">
                  <v-flex justify-start d-flex>
                    <span style="color: #CC3D45;">
                      (วันที่ส่งรายงาน ต้องไม่มากกว่า 60 วัน
                      ก่อนวันหมดอายุการรับรอง)
                    </span>
                  </v-flex>
                </v-layout>

                <!-- row 2 -->
                <v-layout mt-12 style="padding-left: 100px;">
                  <v-flex justify-start d-flex>
                    <span style="font-weight: bold;;font-size: 16px;"
                      >การขอต่ออายุการรับรองโครงร่างการวิจัย</span
                    >
                  </v-flex>
                </v-layout>
                <v-layout style="padding-left: 30vh;">
                  <v-flex justify-start d-flex>
                    <v-radio-group v-model="form.wantRenew" hide-details>
                      <v-radio
                        color="#3E7662"
                        style="padding-right: 100px"
                        label="ขอต่ออายุการรับรอง"
                        value="1"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        style="padding-right: 100px"
                        label="ไม่ขอ เนื่องจากการวิจัยสิ้นสุดแล้ว"
                        value="2"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <!-- row 3 -->
                <!-- <v-layout mt-12 style="padding-left: 100px;">
                  <v-flex justify-start d-flex style="font-weight: bold">
                    <v-checkbox
                      color="#3E7662"
                      label="อื่นๆ ระบุ"
                      v-model="form.hasOther"
                    />
                  </v-flex>
                </v-layout> -->

                <!-- row 4 Blog Tatle -->
                <v-layout ma-12>
                  <v-flex>
                    <!-- Header -->
                    <v-layout
                      py-4
                      style="background-color: #3E7662;color: white;"
                    >
                      <v-flex xs6>
                        <span>1. จำนวนอาสาสมัคร (ค + ง + จ + ฉ = ข)</span>
                      </v-flex>
                      <v-flex xs6>
                        <span>ข้อคิดเห็น</span>
                      </v-flex>
                    </v-layout>

                    <!-- Card 1 -->
                    <v-card outlined>
                      <v-layout>
                        <v-flex
                          xs1
                          style="background-color: #EFEAE7;font-size: 24px;"
                        >
                          <span class="textAlignVer">Trial Progress</span>
                        </v-flex>
                        <v-flex>
                          <!-- row 1 -->
                          <v-layout px-8 pt-6 pb-4>
                            <v-flex xs5>
                              <v-checkbox
                                @change="clearCheckbox('hasPlan')"
                                color="#3E7662"
                                label="1. วางแผนไว้"
                                v-model="form.hasPlan"
                              />
                            </v-flex>
                            <v-flex pl-6>
                              <textarea-form
                                hide-detail
                                :rows="2"
                                :disabled="form.hasPlan === false"
                                :background-color="
                                  form.hasPlan === false ? '#E4E4E4' : '#FBF6F3'
                                "
                                :model="form.plan"
                                @update-data="updateData('plan', $event)"
                              ></textarea-form>
                            </v-flex>
                          </v-layout>
                          <!-- row 2 -->
                          <v-layout
                            px-8
                            pt-6
                            pb-4
                            style="background-color: #FBF6F3"
                          >
                            <v-flex xs5>
                              <v-checkbox
                                @change="clearCheckbox('hasScreen')"
                                color="#3E7662"
                                label="2. คัดเลือกเข้าในการวิจัย"
                                v-model="form.hasScreen"
                              />
                            </v-flex>
                            <v-flex pl-6>
                              <textarea-form
                                hide-detail
                                :rows="2"
                                :disabled="form.hasScreen === false"
                                :background-color="
                                  form.hasScreen === false
                                    ? '#E4E4E4'
                                    : '#FBF6F3'
                                "
                                :model="form.screen"
                                @update-data="updateData('screen', $event)"
                              ></textarea-form>
                            </v-flex>
                          </v-layout>
                          <!-- row 3 -->
                          <v-layout px-8 pt-6 pb-4>
                            <v-flex xs5>
                              <v-checkbox
                                @change="clearCheckbox('hasResearching')"
                                color="#3E7662"
                                label="3. อยู่ในระหว่างดำเนินการวิจัย (มีการทำหัตถการหรือการทดลอง)"
                                v-model="form.hasResearching"
                              />
                            </v-flex>
                            <v-flex pl-6>
                              <textarea-form
                                hide-detail
                                :rows="2"
                                :disabled="form.hasResearching === false"
                                :background-color="
                                  form.hasResearching === false
                                    ? '#E4E4E4'
                                    : '#FBF6F3'
                                "
                                :model="form.researching"
                                @update-data="updateData('researching', $event)"
                              ></textarea-form>
                            </v-flex>
                          </v-layout>
                          <!-- row 4 -->
                          <v-layout
                            px-8
                            pt-6
                            pb-4
                            style="background-color: #FBF6F3"
                          >
                            <v-flex xs5>
                              <v-checkbox
                                @change="clearCheckbox('hasFollowing')"
                                color="#3E7662"
                                label="4. อยู่ในระหว่างการติดตามเท่านั้น"
                                v-model="form.hasFollowing"
                              />
                            </v-flex>
                            <v-flex pl-6>
                              <textarea-form
                                hide-detail
                                :rows="2"
                                :disabled="form.hasFollowing === false"
                                :background-color="
                                  form.hasFollowing === false
                                    ? '#E4E4E4'
                                    : '#FBF6F3'
                                "
                                :model="form.following"
                                @update-data="updateData('following', $event)"
                              ></textarea-form>
                            </v-flex>
                          </v-layout>
                          <!-- row 5 -->
                          <v-layout px-8 pt-6 pb-4>
                            <v-flex xs5>
                              <v-checkbox
                                @change="clearCheckbox('hasWithdraw')"
                                color="#3E7662"
                                label="5. ถอนตัว หรือขาดการติดตาม (รวมที่เสียชีวิต)"
                                v-model="form.hasWithdraw"
                              />
                            </v-flex>
                            <v-flex pl-6>
                              <textarea-form
                                hide-detail
                                :rows="2"
                                :disabled="form.hasWithdraw === false"
                                :background-color="
                                  form.hasWithdraw === false
                                    ? '#E4E4E4'
                                    : '#FBF6F3'
                                "
                                :model="form.withdraw"
                                @update-data="updateData('withdraw', $event)"
                              ></textarea-form>
                            </v-flex>
                          </v-layout>
                          <!-- row 6 -->
                          <v-layout
                            px-8
                            pt-6
                            pb-4
                            style="background-color: #FBF6F3"
                          >
                            <v-flex xs5>
                              <v-checkbox
                                @change="clearCheckbox('hasFinish')"
                                color="#3E7662"
                                label="6. สิ้นสุดการวิจัย"
                                v-model="form.hasFinish"
                              />
                            </v-flex>
                            <v-flex pl-6>
                              <textarea-form
                                hide-detail
                                :rows="2"
                                :disabled="form.hasFinish === false"
                                :background-color="
                                  form.hasFinish === false
                                    ? '#E4E4E4'
                                    : '#FBF6F3'
                                "
                                :model="form.finish"
                                @update-data="updateData('finish', $event)"
                              ></textarea-form>
                            </v-flex>
                          </v-layout>
                          <!-- row 7 -->
                          <v-layout
                            py-6
                            px-6
                            style="background-color: #39896B;"
                          >
                            <v-flex>
                              <v-layout>
                                <v-flex
                                  xs8
                                  style="text-align: left;color: white;font-weight: bold"
                                >
                                  <span
                                    >2. มีอาสาสมัครถอนตัวจากการวิจัย
                                    ในช่วงการรับรองของคณะอนุกรรมการฯ ไม่?</span
                                  >
                                </v-flex>
                                <v-flex xs4 style="text-align: right;">
                                  <v-radio-group
                                    v-model="form.hasWithdrawVolunteer"
                                    hide-details
                                    row
                                    dark
                                  >
                                    <v-radio
                                      color="#fff"
                                      label="มี"
                                      value="1"
                                    ></v-radio>
                                    <v-radio
                                      @click="
                                        clearRedio('hasWithdrawVolunteer', '2')
                                      "
                                      color="#fff"
                                      label="ไม่มี"
                                      value="2"
                                    ></v-radio>
                                    <v-radio
                                      @click="
                                        clearRedio('hasWithdrawVolunteer', '3')
                                      "
                                      color="#fff"
                                      label="ไม่เกี่ยวข้อง"
                                      value="3"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                              <v-layout pl-4>
                                <v-flex
                                  xs8
                                  style="text-align: left;color: white;"
                                >
                                  <span>(ถ้ามี สรุปจำนวนและระบุเหตุผล)</span>
                                </v-flex>
                              </v-layout>
                              <v-layout px-4 mt-4>
                                <v-flex>
                                  <TextareaForm
                                    hide-detail
                                    :rows="4"
                                    :disabled="
                                      form.hasWithdrawVolunteer !== '1'
                                    "
                                    :background-color="
                                      form.hasWithdrawVolunteer !== '1'
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.withdrawVolunteer"
                                    @update-data="
                                      updateData('withdrawVolunteer', $event)
                                    "
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>

                    <!-- Card 2 -->
                    <v-card outlined class="mt-8">
                      <v-layout>
                        <v-flex
                          xs1
                          style="background-color: #EFEAE7;font-size: 24px;"
                        >
                          <span class="textAlignVer"
                            >Protocol Related Documents</span
                          >
                        </v-flex>
                        <v-flex>
                          <!-- row 1 -->
                          <v-layout
                            py-6
                            px-6
                            style="background-color: #39896B;"
                          >
                            <v-flex>
                              <v-layout>
                                <v-flex
                                  xs8
                                  style="text-align: left;color: white;font-weight: bold;"
                                >
                                  <span
                                    >3. มีส่วนแก้ไขเพิ่มเติมโครงร่างการวิจัย
                                    ในช่วงการรับรองของคณะอนุกรรมการฯหรือไม่</span
                                  >
                                </v-flex>
                                <v-flex xs4 style="text-align: right;">
                                  <v-radio-group
                                    v-model="form.hasEdit"
                                    hide-details
                                    row
                                    dark
                                  >
                                    <v-radio
                                      color="#fff"
                                      label="มี"
                                      value="1"
                                    ></v-radio>
                                    <v-radio
                                      @click="clearRedio('hasEdit', '2')"
                                      color="#fff"
                                      label="ไม่มี"
                                      value="2"
                                    ></v-radio>
                                    <v-radio
                                      @click="clearRedio('hasEdit', '3')"
                                      color="#fff"
                                      label="ไม่เกี่ยวข้อง"
                                      value="3"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                              <v-layout pl-4>
                                <v-flex
                                  xs8
                                  style="text-align: left;color: white;"
                                >
                                  <span>(ถ้ามี สรุปสั้นๆ)</span>
                                </v-flex>
                              </v-layout>
                              <v-layout px-4 mt-4>
                                <v-flex>
                                  <TextareaForm
                                    hide-detail
                                    :rows="4"
                                    :disabled="form.hasEdit !== '1'"
                                    :background-color="
                                      form.hasEdit !== '1'
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.edit"
                                    @update-data="updateData('edit', $event)"
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <!-- row 2 -->
                          <v-layout py-6 px-6 style="background-color: #fff;">
                            <v-flex>
                              <v-layout>
                                <v-flex
                                  xs8
                                  style="text-align: left;font-weight: bold;"
                                >
                                  <span
                                    >4. มีการเปลี่ยนแปลงคู่มือผู้วิจัย
                                    (investigator’s
                                    brochure)ในช่วงการรับรอง</span
                                  >
                                </v-flex>
                                <v-flex xs4 style="text-align: right;">
                                  <v-radio-group
                                    v-model="form.hasEditBrochure"
                                    hide-details
                                    row
                                  >
                                    <v-radio
                                      color="#39896B"
                                      label="มี"
                                      value="1"
                                    ></v-radio>
                                    <v-radio
                                      color="#39896B"
                                      label="ไม่เกี่ยวข้อง"
                                      value="3"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                              <v-layout pl-4>
                                <v-flex xs8 style="text-align: left;">
                                  <span>ของคณะอนุกรรมการฯหรือไม่?</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <!-- row 3 -->
                          <v-layout
                            py-6
                            px-6
                            style="background-color: #39896B;"
                          >
                            <v-flex>
                              <v-layout>
                                <v-flex
                                  xs8
                                  style="text-align: left;color: white;font-weight: bold;"
                                >
                                  <span
                                    >5. มีข้อมูลใหม่ที่เกี่ยวข้องกับการวิจัย
                                    ในช่วงการรับรองของคณะอนุกรรมการฯหรือไม่?</span
                                  >
                                </v-flex>
                                <v-flex xs4 style="text-align: right;">
                                  <v-radio-group
                                    v-model="form.hasNewInformation"
                                    hide-details
                                    row
                                    dark
                                  >
                                    <v-radio
                                      color="#fff"
                                      label="มี"
                                      value="1"
                                    ></v-radio>
                                    <v-radio
                                      @click="
                                        clearRedio('hasNewInformation', '2')
                                      "
                                      color="#fff"
                                      label="ไม่มี"
                                      value="2"
                                    ></v-radio>
                                    <v-radio
                                      @click="
                                        clearRedio('hasNewInformation', '3')
                                      "
                                      color="#fff"
                                      label="ไม่เกี่ยวข้อง"
                                      value="3"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                              <v-layout pl-4>
                                <v-flex
                                  xs8
                                  style="text-align: left;color: white;"
                                >
                                  <span>(ถ้ามี สรุปสั้นๆ)</span>
                                </v-flex>
                              </v-layout>
                              <v-layout px-4 mt-4>
                                <v-flex>
                                  <TextareaForm
                                    hide-detail
                                    :rows="4"
                                    :disabled="form.hasNewInformation !== '1'"
                                    :background-color="
                                      form.hasNewInformation !== '1'
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.newInformation"
                                    @update-data="
                                      updateData('newInformation', $event)
                                    "
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>

                    <!-- Card 3 -->
                    <v-card outlined class="mt-8">
                      <v-layout>
                        <v-flex
                          xs1
                          style="background-color: #EFEAE7;font-size: 24px;"
                        >
                          <span class="textAlignVer">Risk&Benefit</span>
                        </v-flex>
                        <v-flex>
                          <!-- row 1 -->
                          <v-layout
                            py-6
                            px-6
                            style="background-color: #39896B;"
                          >
                            <v-flex>
                              <v-layout>
                                <v-flex
                                  xs8
                                  style="text-align: left;color: white;"
                                >
                                  <span
                                    ><b
                                      >6.
                                      มีปัญหาเกี่ยวกับงานวิจัยที่เพิ่มความเสี่ยงต่ออาสาสมัครในช่วงการรับรองของ
                                      คณะอนุกรรมการฯหรือไม่? </b
                                    >(ถ้ามี สรุปสั้นๆ)</span
                                  >
                                </v-flex>
                                <v-flex xs4 style="text-align: right;">
                                  <v-radio-group
                                    v-model="form.hasIssue"
                                    hide-details
                                    row
                                    dark
                                  >
                                    <v-radio
                                      color="#fff"
                                      label="มี"
                                      value="1"
                                    ></v-radio>
                                    <v-radio
                                      @click="clearRedio('hasIssue', '2')"
                                      color="#fff"
                                      label="ไม่มี"
                                      value="2"
                                    ></v-radio>
                                    <v-radio
                                      @click="clearRedio('hasIssue', '3')"
                                      color="#fff"
                                      label="ไม่เกี่ยวข้อง"
                                      value="3"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                              <v-layout px-4 mt-4>
                                <v-flex>
                                  <TextareaForm
                                    hide-detail
                                    :rows="4"
                                    :disabled="form.hasIssue !== '1'"
                                    :background-color="
                                      form.hasIssue !== '1'
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.issue"
                                    @update-data="updateData('issue', $event)"
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <!-- row 2 -->
                          <v-layout py-6 px-6 style="background-color: #fff;">
                            <v-flex>
                              <v-layout>
                                <v-flex xs8 style="text-align: left;">
                                  <span
                                    ><b
                                      >7.
                                      มีการเปลี่ยนแปลงอัตราส่วนของความเสี่ยงต่อประโยชน์ในช่วงการรับรองของ
                                      คณะอนุกรรมการฯหรือไม่
                                    </b>
                                    (ถ้ามี สรุปสั้นๆ)</span
                                  >
                                </v-flex>
                                <v-flex xs4 style="text-align: right;">
                                  <v-radio-group
                                    v-model="form.hasChangeRatio"
                                    hide-details
                                    row
                                  >
                                    <v-radio
                                      color="#39896B"
                                      label="มี"
                                      value="1"
                                    ></v-radio>
                                    <v-radio
                                      @click="clearRedio('hasChangeRatio', '2')"
                                      color="#39896B"
                                      label="ไม่มี"
                                      value="2"
                                    ></v-radio>
                                    <v-radio
                                      @click="clearRedio('hasChangeRatio', '3')"
                                      color="#39896B"
                                      label="ไม่เกี่ยวข้อง"
                                      value="3"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                              <v-layout px-4 mt-4>
                                <v-flex>
                                  <TextareaForm
                                    hide-detail
                                    :rows="4"
                                    :disabled="form.hasChangeRatio !== '1'"
                                    :background-color="
                                      form.hasChangeRatio !== '1'
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.changeRatio"
                                    @update-data="
                                      updateData('changeRatio', $event)
                                    "
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>

                    <!-- Card 4 -->
                    <v-card outlined class="mt-8">
                      <v-layout>
                        <v-flex
                          xs1
                          style="background-color: #EFEAE7;font-size: 24px;"
                        >
                          <span class="textAlignVer">Informed consent</span>
                        </v-flex>
                        <v-flex>
                          <!-- row 1 -->
                          <v-layout
                            py-6
                            px-6
                            style="background-color: #39896B;"
                          >
                            <v-flex>
                              <v-layout>
                                <v-flex
                                  xs8
                                  style="text-align: left;color: white;"
                                >
                                  <span
                                    ><b
                                      >8.
                                      มีการเปลี่ยนแปลงเอกสารชี้แจงข้อมูลแก่อาสาสมัคร
                                      ในช่วงการรับรองของ คณะอนุกรรมการฯหรือไม่? </b
                                    >(ถ้ามี สรุปสั้นๆ)</span
                                  >
                                </v-flex>
                                <v-flex xs4 style="text-align: right;">
                                  <v-radio-group
                                    v-model="form.hasChangeDocument"
                                    hide-details
                                    row
                                    dark
                                  >
                                    <v-radio
                                      color="#fff"
                                      label="มี"
                                      value="1"
                                    ></v-radio>
                                    <v-radio
                                      @click="
                                        clearRedio('hasChangeDocument', '2')
                                      "
                                      color="#fff"
                                      label="ไม่มี"
                                      value="2"
                                    ></v-radio>
                                    <v-radio
                                      @click="
                                        clearRedio('hasChangeDocument', '3')
                                      "
                                      color="#fff"
                                      label="ไม่เกี่ยวข้อง"
                                      value="3"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                              <v-layout px-4 mt-4>
                                <v-flex>
                                  <TextareaForm
                                    hide-detail
                                    :rows="4"
                                    :disabled="form.hasChangeDocument !== '1'"
                                    :background-color="
                                      form.hasChangeDocument !== '1'
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.changeDocument"
                                    @update-data="
                                      updateData('changeDocument', $event)
                                    "
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <!-- row 2 -->
                          <v-layout py-6 px-6 style="background-color: #fff;">
                            <v-flex>
                              <v-layout>
                                <v-flex xs8 style="text-align: left;">
                                  <span
                                    ><b
                                      >9.
                                      มีปัญหาในกระบวนการขอความยินยอมจากอาสาสมัครในช่วงการรับรองของ
                                      คณะอนุกรรมการฯหรือไม่?
                                    </b>
                                    (ถ้ามี สรุปสั้นๆ)</span
                                  >
                                </v-flex>
                                <v-flex xs4 style="text-align: right;">
                                  <v-radio-group
                                    v-model="form.hasConsentIssue"
                                    hide-details
                                    row
                                  >
                                    <v-radio
                                      color="#39896B"
                                      label="มี"
                                      value="1"
                                    ></v-radio>
                                    <v-radio
                                      @click="
                                        clearRedio('hasConsentIssue', '2')
                                      "
                                      color="#39896B"
                                      label="ไม่มี"
                                      value="2"
                                    ></v-radio>
                                    <v-radio
                                      @click="
                                        clearRedio('hasConsentIssue', '3')
                                      "
                                      color="#39896B"
                                      label="ไม่เกี่ยวข้อง"
                                      value="3"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                              <v-layout px-4 mt-4>
                                <v-flex>
                                  <TextareaForm
                                    hide-detail
                                    :rows="4"
                                    :disabled="form.hasConsentIssue !== '1'"
                                    :background-color="
                                      form.hasConsentIssue !== '1'
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.consentIssue"
                                    @update-data="
                                      updateData('consentIssue', $event)
                                    "
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>

                    <!-- Card 5 -->
                    <v-card outlined class="mt-8">
                      <v-layout>
                        <v-flex
                          xs1
                          style="background-color: #EFEAE7;font-size: 24px;"
                        >
                          <span class="textAlignVer">local issues</span>
                        </v-flex>
                        <v-flex>
                          <!-- row 1 -->
                          <v-layout
                            py-6
                            px-6
                            style="background-color: #39896B;"
                          >
                            <v-flex>
                              <v-layout>
                                <v-flex
                                  xs8
                                  style="text-align: left;color: white;"
                                >
                                  <span
                                    ><b
                                      >10.
                                      มีเรื่องร้องเรียนของอาสาสมัครเกี่ยวกับโครงการวิจัยจากอาสาในช่วงการรับรองของ
                                      คณะอนุกรรมการฯหรือไม่? </b
                                    >(ถ้ามี สรุปสั้นๆ)</span
                                  >
                                </v-flex>
                                <v-flex xs4 style="text-align: right;">
                                  <v-radio-group
                                    v-model="form.hasComplaint"
                                    hide-details
                                    row
                                    dark
                                  >
                                    <v-radio
                                      color="#fff"
                                      label="มี"
                                      value="1"
                                    ></v-radio>
                                    <v-radio
                                      @click="clearRedio('hasComplaint', '2')"
                                      color="#fff"
                                      label="ไม่มี"
                                      value="2"
                                    ></v-radio>
                                    <v-radio
                                      @click="clearRedio('hasComplaint', '3')"
                                      color="#fff"
                                      label="ไม่เกี่ยวข้อง"
                                      value="3"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                              <v-layout px-4 mt-4>
                                <v-flex>
                                  <TextareaForm
                                    hide-detail
                                    :rows="4"
                                    :disabled="form.hasComplaint !== '1'"
                                    :background-color="
                                      form.hasComplaint !== '1'
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.complaint"
                                    @update-data="
                                      updateData('complaint', $event)
                                    "
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <!-- row 2 -->
                          <v-layout py-6 px-6 style="background-color: #fff;">
                            <v-flex>
                              <v-layout>
                                <v-flex xs8 pr-4 style="text-align: left;">
                                  <span
                                    ><b
                                      >11. มีผลกระทบในด้านทัศนคติเชิงลบ
                                      ของชุมชนต่อโครงการวิจัย ในช่วงการรับรองของ
                                      คณะอนุกรรมการฯหรือไม่ ?
                                    </b>
                                    (ถ้ามี สรุปสั้นๆ)</span
                                  >
                                </v-flex>
                                <v-flex xs4 style="text-align: right;">
                                  <v-radio-group
                                    v-model="form.hasBadEffect"
                                    hide-details
                                    row
                                  >
                                    <v-radio
                                      color="#39896B"
                                      label="มี"
                                      value="1"
                                    ></v-radio>
                                    <v-radio
                                      @click="clearRedio('hasBadEffect', '2')"
                                      color="#39896B"
                                      label="ไม่มี"
                                      value="2"
                                    ></v-radio>
                                    <v-radio
                                      @click="clearRedio('hasBadEffect', '3')"
                                      color="#39896B"
                                      label="ไม่เกี่ยวข้อง"
                                      value="3"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                              <v-layout px-4 mt-4>
                                <v-flex>
                                  <TextareaForm
                                    hide-detail
                                    :rows="4"
                                    :disabled="form.hasBadEffect !== '1'"
                                    :background-color="
                                      form.hasBadEffect !== '1'
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.badEffect"
                                    @update-data="
                                      updateData('badEffect', $event)
                                    "
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>

                    <!-- Card 6 -->
                    <v-card outlined class="mt-8">
                      <v-layout>
                        <v-flex
                          xs1
                          style="background-color: #EFEAE7;font-size: 24px;"
                        >
                          <span class="textAlignVer">Investigators</span>
                        </v-flex>
                        <v-flex>
                          <!-- row 1 -->
                          <v-layout
                            py-6
                            px-6
                            style="background-color: #39896B;"
                          >
                            <v-flex>
                              <v-layout>
                                <v-flex
                                  xs8
                                  style="text-align: left;color: white;"
                                >
                                  <span
                                    ><b
                                      >12. มีการเปลี่ยนผู้วิจัยหลัก
                                      หรือผู้วิจัยร่วมในช่วงการรับรองของ
                                      คณะอนุกรรมการฯหรือไม่ ?
                                    </b></span
                                  >
                                </v-flex>
                                <v-flex xs4 style="text-align: right;">
                                  <v-radio-group
                                    v-model="form.hasChangeMainResearcher"
                                    hide-details
                                    row
                                    dark
                                  >
                                    <v-radio
                                      color="#fff"
                                      label="มี"
                                      value="1"
                                    ></v-radio>
                                    <v-radio
                                      @click="
                                        clearRedio(
                                          'hasChangeMainResearcher',
                                          '2'
                                        )
                                      "
                                      color="#fff"
                                      label="ไม่มี"
                                      value="2"
                                    ></v-radio>
                                    <v-radio
                                      @click="
                                        clearRedio(
                                          'hasChangeMainResearcher',
                                          '3'
                                        )
                                      "
                                      color="#fff"
                                      label="ไม่เกี่ยวข้อง"
                                      value="3"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                              <v-layout pl-4>
                                <v-flex
                                  xs8
                                  style="text-align: left;color: white;"
                                >
                                  <span>(ถ้ามี สรุปสั้นๆ)</span>
                                </v-flex>
                              </v-layout>
                              <v-layout px-4 mt-4>
                                <v-flex>
                                  <TextareaForm
                                    hide-detail
                                    :rows="4"
                                    :disabled="
                                      form.hasChangeMainResearcher !== '1'
                                    "
                                    :background-color="
                                      form.hasChangeMainResearcher !== '1'
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.changeMainResearcher"
                                    @update-data="
                                      updateData('changeMainResearcher', $event)
                                    "
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <!-- row 2 -->
                          <v-layout py-6 px-6 style="background-color: #fff;">
                            <v-flex>
                              <v-layout>
                                <v-flex xs8 pr-4 style="text-align: left;">
                                  <span
                                    ><b
                                      >13.
                                      มีการเปลี่ยนแปลงฐานะหรือคุณสมบัติของผู้วิจัยในช่วงการรับรองของ
                                      คณะอนุกรรมการฯหรือไม่ ? </b
                                    >(ถ้ามี สรุปสั้นๆ)</span
                                  >
                                </v-flex>
                                <v-flex xs4 style="text-align: right;">
                                  <v-radio-group
                                    v-model="form.hasChangeResearcherProperty"
                                    hide-details
                                    row
                                  >
                                    <v-radio
                                      color="#39896B"
                                      label="มี"
                                      value="1"
                                    ></v-radio>
                                    <v-radio
                                      @click="
                                        clearRedio(
                                          'hasChangeResearcherProperty',
                                          '2'
                                        )
                                      "
                                      color="#39896B"
                                      label="ไม่มี"
                                      value="2"
                                    ></v-radio>
                                    <v-radio
                                      @click="
                                        clearRedio(
                                          'hasChangeResearcherProperty',
                                          '3'
                                        )
                                      "
                                      color="#39896B"
                                      label="ไม่เกี่ยวข้อง"
                                      value="3"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                              <v-layout px-4 mt-4>
                                <v-flex>
                                  <TextareaForm
                                    hide-detail
                                    :rows="4"
                                    :disabled="
                                      form.hasChangeResearcherProperty !== '1'
                                    "
                                    :background-color="
                                      form.hasChangeResearcherProperty !== '1'
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.changeResearcherProperty"
                                    @update-data="
                                      updateData(
                                        'changeResearcherProperty',
                                        $event
                                      )
                                    "
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>

                    <!-- Card 7 -->
                    <v-card outlined class="mt-8">
                      <v-layout>
                        <v-flex
                          xs1
                          style="background-color: #EFEAE7;font-size: 24px;"
                        >
                          <span class="textAlignVer">Other issues</span>
                        </v-flex>
                        <v-flex>
                          <!-- row 1 -->
                          <v-layout
                            py-6
                            px-6
                            style="background-color: #39896B;"
                          >
                            <v-flex>
                              <v-layout>
                                <v-flex
                                  xs8
                                  style="text-align: left;color: white;"
                                >
                                  <span
                                    ><b
                                      >14. มีข้อกังวลของผู้วิจัย
                                      เกี่ยวกับโครงการวิจัยในช่วงการรับรองของ
                                      คณะอนุกรรมการฯหรือไม่? </b
                                    >(ถ้ามี สรุปสั้นๆ)</span
                                  >
                                </v-flex>
                                <v-flex xs4 style="text-align: right;">
                                  <v-radio-group
                                    v-model="form.hasConcern"
                                    hide-details
                                    row
                                    dark
                                  >
                                    <v-radio
                                      color="#fff"
                                      label="มี"
                                      value="1"
                                    ></v-radio>
                                    <v-radio
                                      @click="clearRedio('hasConcern', '2')"
                                      color="#fff"
                                      label="ไม่มี"
                                      value="2"
                                    ></v-radio>
                                    <v-radio
                                      @click="clearRedio('hasConcern', '3')"
                                      color="#fff"
                                      label="ไม่เกี่ยวข้อง"
                                      value="3"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                              <v-layout px-4 mt-4>
                                <v-flex>
                                  <TextareaForm
                                    hide-detail
                                    :rows="4"
                                    :disabled="form.hasConcern !== '1'"
                                    :background-color="
                                      form.hasConcern !== '1'
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.concern"
                                    @update-data="updateData('concern', $event)"
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <!-- row 2 -->
                          <v-layout py-6 px-6 style="background-color: #fff;">
                            <v-flex>
                              <v-layout>
                                <v-flex xs8 pr-4 style="text-align: left;">
                                  <span
                                    ><b
                                      >15.
                                      มีข้อมูลจากคณะกรรมการกำกับดูแลโครงการวิจัย
                                      (data monitoring- committees, DMCs)
                                      ในช่วงการรับรองของคณะอนุกรรมการฯหรือไม่? </b
                                    >(ถ้ามี สรุปสั้นๆ)</span
                                  >
                                </v-flex>
                                <v-flex xs4 style="text-align: right;">
                                  <v-radio-group
                                    v-model="form.hasInformationFromCommittee"
                                    hide-details
                                    row
                                  >
                                    <v-radio
                                      color="#39896B"
                                      label="มี"
                                      value="1"
                                    ></v-radio>
                                    <v-radio
                                      @click="
                                        clearRedio(
                                          'hasInformationFromCommittee',
                                          '2'
                                        )
                                      "
                                      color="#39896B"
                                      label="ไม่มี"
                                      value="2"
                                    ></v-radio>
                                    <v-radio
                                      @click="
                                        clearRedio(
                                          'hasInformationFromCommittee',
                                          '3'
                                        )
                                      "
                                      color="#39896B"
                                      label="ไม่เกี่ยวข้อง"
                                      value="3"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                              <v-layout px-4 mt-4>
                                <v-flex>
                                  <TextareaForm
                                    hide-detail
                                    :rows="4"
                                    :disabled="
                                      form.hasInformationFromCommittee !== '1'
                                    "
                                    :background-color="
                                      form.hasInformationFromCommittee !== '1'
                                        ? '#E4E4E4'
                                        : '#FBF6F3'
                                    "
                                    :model="form.informationFromCommittee"
                                    @update-data="
                                      updateData(
                                        'informationFromCommittee',
                                        $event
                                      )
                                    "
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>

                <!-- row 5 -->
                <v-layout my-6 px-12>
                  <v-flex style="font-weight: bold; text-align: left;">
                    <span>สรุปข้อมูลเพิ่มเติม</span>
                  </v-flex>
                </v-layout>
                <v-layout px-12>
                  <v-flex>
                    <TextareaForm
                      :rows="10"
                      :model="form.summarize"
                      @update-data="updateData('summarize', $event)"
                    />
                  </v-flex>
                </v-layout>

                <v-layout class="mb-12 px-12">
                  <v-flex>
                    <v-layout class="mb-8">
                      <v-flex>
                        <v-layout>
                          <v-flex shrink pt-2 pr-4 style="text-align: left;">
                            <span style="font-weight: bold;font-size: 16px;"
                              >หนังสือของหน่วยงาน
                            </span>
                          </v-flex>
                          <v-flex>
                            <v-file-input
                              accept=".pdf"
                              prepend-icon=""
                              ref="agencyBooks"
                              id="agencyBook"
                              :model="form.agencyBook"
                              outlined
                              dense
                              clearable
                              background-color="#FBF6F3"
                              color="#3E7662"
                              item-color="#3E7662"
                              @change="onUpload"
                              hide-details
                            ></v-file-input>
                            <div
                              v-if="agencyBook"
                              class="mt-1 text-start"
                              style="font-size: 12px;color: #CC3D45;"
                            >
                              <span>ไฟล์ที่อัพโหลด: {{ agencyBook }}</span>
                            </div>
                          </v-flex>
                          <v-flex shrink pl-4 style="text-align: left">
                            <v-btn color="#3E7662" dark @click="onClickBtn">
                              <v-icon class="pr-3">cloud_download</v-icon>
                              <span>Upload</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>

                    <v-layout>
                      <v-flex xs6>
                        <v-layout>
                          <v-flex
                            class="d-flex align-center mr-4 font-weight-bold"
                            shrink
                            >เลขหนังสือ</v-flex
                          >
                          <v-flex>
                            <textfield-form
                              hide-detail
                              :model="form.bookNumber"
                              @update-data="updateData('bookNumber', $event)"
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex xs6>
                        <v-layout>
                          <v-flex
                            class="d-flex align-center mx-4 font-weight-bold"
                            shrink
                            >วันที่หนังสือ</v-flex
                          >
                          <v-flex>
                            <DateInputForm
                              id="orderDate"
                              hide-detail
                              :model="bookDate"
                              @update-data="updateDate('bookDate', $event)"
                            ></DateInputForm>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- row 6 -->
                <v-layout my-6 px-12>
                  <v-flex
                    @click="setData"
                    mr-12
                    xs5
                    style="text-align: left;"
                    class="text-field-center"
                  >
                    <textfield-form-append
                      css="font-weight: bold;"
                      label="ผู้วิจัย"
                      icon="edit"
                      :model="form.signature"
                      @update-data="updateData('signature', $event)"
                      hide-detail
                    />
                  </v-flex>
                  <v-flex shrink pt-2 mr-4 style="font-weight: bold;">
                    <span>วันที่</span>
                  </v-flex>
                  <v-flex xs3>
                    <DateInputForm
                      hide-detail
                      :model="date"
                      @update-data="updateDate('date', $event)"
                    />
                  </v-flex>
                </v-layout>
                <v-layout mt-6 px-12>
                  <v-flex xs5>
                    <v-layout justify-center>
                      <v-flex shrink style="font-weight: bold">
                        <span>(</span>
                      </v-flex>
                      <v-flex xs8 mx-2 mt-n3 class="text-field-center">
                        <textfield-form-append
                          :model="form.signature"
                          @update-data="updateData('signature', $event)"
                        />
                      </v-flex>
                      <v-flex shrink style="font-weight: bold">
                        <span>)</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- Button Save -->
            <v-layout mt-8>
              <v-flex mb-12 style="text-align: right;">
                <v-layout>
                  <v-flex>
                    <v-btn
                      style="color: #3E7662"
                      class="mx-4"
                      depressed
                      color="#ffffff"
                      @click="viewData"
                      >ย้อนกลับ</v-btn
                    >
                    <v-btn depressed dark color="#3E7662" @click="save">
                      <v-icon class="mr-3">add</v-icon>
                      <span>บันทึกข้อมูล</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <loading
          color="#527281"
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-pageAndLine="fullpageAndLine"
        ></loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";

export default {
  name: "FormRF06",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
  },
  computed: {
    ...mapState({
      researchID: (state) => state.formRF.researchID,
    }),
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    isLoading: false,
    fullpageAndLine: true,
    selected: [],
    dialog: false,
    form: {
      researchCode: "",
      firstName: "",
      lastName: "",
      researchName: "",
      lastDay: "",
      startDay: "",
      endDay: "",
      reportDate: "",
      reportTime: "",
      wantRenew: "",
      hasOther: false,
      hasPlan: false,
      plan: "",
      hasScreen: false,
      screen: "",
      hasResearching: false,
      researching: "",
      hasFollowing: false,
      following: "",
      hasWithdraw: false,
      withdraw: "",
      hasFinish: false,
      finish: "",
      hasWithdrawVolunteer: "2",
      withdrawVolunteer: "",
      hasEdit: "2",
      edit: "",
      hasEditBrochure: "2",
      hasNewInformation: "2",
      newInformation: "",
      hasIssue: "2",
      issue: "",
      hasChangeRatio: "2",
      changeRatio: "",
      hasChangeDocument: "2",
      changeDocument: "",
      hasConsentIssue: "2",
      consentIssue: "",
      hasComplaint: "2",
      complaint: "",
      hasBadEffect: "2",
      badEffect: "",
      hasChangeMainResearcher: "2",
      changeMainResearcher: "",
      hasChangeResearcherProperty: "2",
      changeResearcherProperty: "",
      hasConcern: "2",
      concern: "",
      hasInformationFromCommittee: "2",
      informationFromCommittee: "",
      summarize: "",
      agencyBook: "",
      bookNumber: "",
      bookDate: "",
      signature: "",
      date: "",
    },
    agencyBook: "",
    userID: "",
    lastDay: "",
    startDay: "",
    endDay: "",
    reportDate: "",
    date: "",
    bookDate: "",
  }),
  created() {
    this.userID = this.$route.query.userID;
    this.getRF03();
  },
  methods: {
    updateData(name, val) {
      this.form[name] = val;
    },
    updateDate(name, val) {
      if (name === "lastDay") {
        this.form.lastDay = val.date;
        this.lastDay = this.changeDate(val.date);
      }
      if (name === "startDay") {
        this.form.startDay = val.date;
        this.startDay = this.changeDate(val.date);
      }
      if (name === "endDay") {
        this.form.endDay = val.date;
        this.endDay = this.changeDate(val.date);
      }
      if (name === "reportDate") {
        this.form.reportDate = val.date;
        this.reportDate = this.changeDate(val.date);
      }
      if (name === "date") {
        this.form.date = val.date;
        this.date = this.changeDate(val.date);
      }
      if (name === "bookDate") {
        this.form.bookDate = val.date;
        this.bookDate = this.changeDate(val.date);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    tableUpdateData(name, val) {
      this.edit[name] = val;
    },
    tableEditUpdateData(name, val) {
      this.information[name] = val;
    },
    viewData() {
      this.$router.push({
        name: "ViewDataPostApprove",
        query: { id: this.userID },
      });
    },
    getRF03() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRF/getRF03", this.$route.query.id)
        .then((res) => {
          this.form.researchCode = res.researchCode;
          this.form.firstName = res.firstName;
          this.form.lastName = res.lastName;
          this.form.researchName = res.researchName;
          this.form.lastDay = res.lastDay;
          this.lastDay = this.changeDate(res.lastDay);
          this.form.startDay = res.startDay;
          this.startDay = this.changeDate(res.startDay);
          this.form.endDay = res.endDay;
          this.endDay = this.changeDate(res.endDay);
          this.form.reportDate = res.reportDate;
          this.reportDate = this.changeDate(res.reportDate);
          this.form.reportTime = res.reportTime.toString();
          this.form.wantRenew = res.wantRenew.toString();
          this.form.hasOther = res.hasOther.toString();
          this.form.hasPlan = res.hasPlan.toString();
          this.form.plan = res.plan;
          this.form.hasScreen = res.hasScreen.toString();
          this.form.screen = res.screen;
          this.form.hasResearching = res.hasResearching.toString();
          this.form.researching = res.researching;
          this.form.hasFollowing = res.hasFollowing.toString();
          this.form.following = res.following;
          this.form.hasWithdraw = res.hasWithdraw.toString();
          this.form.withdraw = res.withdraw;
          this.form.hasFinish = res.hasFinish.toString();
          this.form.finish = res.finish;
          this.form.hasWithdrawVolunteer = res.hasWithdrawVolunteer.toString();
          this.form.withdrawVolunteer = res.withdrawVolunteer;
          this.form.hasEdit = res.hasEdit.toString();
          this.form.edit = res.edit;
          this.form.hasEditBrochure = res.hasEditBrochure.toString();
          this.form.hasNewInformation = res.hasNewInformation.toString();
          this.form.newInformation = res.newInformation;
          this.form.hasIssue = res.hasIssue.toString();
          this.form.issue = res.issue;
          this.form.hasChangeRatio = res.hasChangeRatio.toString();
          this.form.changeRatio = res.changeRatio;
          this.form.hasChangeDocument = res.hasChangeDocument.toString();
          this.form.changeDocument = res.changeDocument;
          this.form.hasConsentIssue = res.hasConsentIssue.toString();
          this.form.consentIssue = res.consentIssue;
          this.form.hasComplaint = res.hasComplaint.toString();
          this.form.complaint = res.complaint;
          this.form.hasBadEffect = res.hasBadEffect.toString();
          this.form.badEffect = res.badEffect;
          this.form.hasChangeMainResearcher = res.hasChangeMainResearcher.toString();
          this.form.changeMainResearcher = res.changeMainResearcher;
          this.form.hasChangeResearcherProperty = res.hasChangeResearcherProperty.toString();
          this.form.changeResearcherProperty = res.changeResearcherProperty;
          this.form.hasConcern = res.hasConcern.toString();
          this.form.concern = res.concern;
          this.form.hasInformationFromCommittee = res.hasInformationFromCommittee.toString();
          this.form.informationFromCommittee = res.informationFromCommittee;
          this.form.summarize = res.summarize;
          this.form.signature = res.signature;
          this.form.agencyBook = res.agencyBook;
          this.agencyBook = res.agencyBook;
          this.form.bookDate = res.bookDate;
          this.bookDate = this.changeDate(res.bookDate);
          this.form.bookNumber = res.bookNumber;
          this.form.date = res.date;
          this.date = this.changeDate(res.date);
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    save() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.$store
            .dispatch("FormRF/saveRF03", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              });
              this.isLoading = false;
              this.viewData();
              // this.$router.push('/profile')
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // })
              // this.isLoading = false;
            });
        }
      });
    },
    setData() {
      this.form.researchCode = "Test";
      this.form.firstName = "Test";
      this.form.lastName = "Test";
      this.form.researchName = "Test";
      this.form.lastDay = "2020-02-12";
      this.form.startDay = "2020-02-12";
      this.form.endDay = "2020-02-12";
      this.form.reportDate = "2020-02-12";
      this.form.reportTime = "1";
      this.form.wantRenew = "1";
      this.form.hasOther = true;
      this.form.hasPlan = true;
      this.form.plan = "Test";
      this.form.hasScreen = true;
      this.form.screen = "Test";
      this.form.hasResearching = true;
      this.form.researching = "Test";
      this.form.hasFollowing = true;
      this.form.following = "Test";
      this.form.hasWithdraw = true;
      this.form.withdraw = "Test";
      this.form.hasFinish = true;
      this.form.finish = "Test";
      this.form.hasWithdrawVolunteer = "1";
      this.form.withdrawVolunteer = "Test";
      this.form.hasEdit = "1";
      this.form.edit = "Test";
      this.form.hasEditBrochure = "1";
      this.form.hasNewInformation = "1";
      this.form.newInformation = "Test";
      this.form.hasIssue = "1";
      this.form.issue = "Test";
      this.form.hasChangeRatio = "1";
      this.form.changeRatio = "Test";
      this.form.hasChangeDocument = "1";
      this.form.changeDocument = "Test";
      this.form.hasConsentIssue = "1";
      this.form.consentIssue = "Test";
      this.form.hasComplaint = "1";
      this.form.complaint = "Test";
      this.form.hasBadEffect = "1";
      this.form.badEffect = "Test";
      this.form.hasChangeMainResearcher = "1";
      this.form.changeMainResearcher = "Test";
      this.form.hasChangeResearcherProperty = "1";
      this.form.changeResearcherProperty = "Test";
      this.form.hasConcern = "1";
      this.form.concern = "Test";
      this.form.hasInformationFromCommittee = "1";
      this.form.informationFromCommittee = "Test";
      this.form.summarize = "Test";
      this.form.signature = "ดำ ใจดี";
      this.form.date = "2020-02-12";
    },
    clearCheckbox(name) {
      if (name === "hasPlan") {
        if (this.form.hasPlan === false) {
          this.form.plan = "";
        }
      }
      if (name === "hasScreen") {
        if (this.form.hasScreen === false) {
          this.form.screen = "";
        }
      }
      if (name === "hasResearching") {
        if (this.form.hasResearching === false) {
          this.form.researching = "";
        }
      }
      if (name === "hasFollowing") {
        if (this.form.hasFollowing === false) {
          this.form.following = "";
        }
      }
      if (name === "hasWithdraw") {
        if (this.form.hasWithdraw === false) {
          this.form.withdraw = "";
        }
      }
      if (name === "hasFinish") {
        if (this.form.hasFinish === false) {
          this.form.finish = "";
        }
      }
    },
    clearRedio(name, val) {
      if (name === "hasWithdrawVolunteer") {
        this.form.withdrawVolunteer = "";
        this.form.hasWithdrawVolunteer = val;
      }
      if (name === "hasEdit") {
        this.form.edit = "";
        this.form.hasEdit = val;
      }
      if (name === "hasNewInformation") {
        this.form.newInformation = "";
        this.form.hasNewInformation = val;
      }
      if (name === "hasIssue") {
        this.form.issue = "";
        this.form.hasIssue = val;
      }
      if (name === "hasChangeRatio") {
        this.form.changeRatio = "";
        this.form.hasChangeRatio = val;
      }
      if (name === "hasChangeDocument") {
        this.form.changeDocument = "";
        this.form.hasChangeDocument = val;
      }
      if (name === "hasConsentIssue") {
        this.form.consentIssue = "";
        this.form.hasConsentIssue = val;
      }
      if (name === "hasComplaint") {
        this.form.complaint = "";
        this.form.hasComplaint = val;
      }
      if (name === "hasBadEffect") {
        this.form.badEffect = "";
        this.form.hasBadEffect = val;
      }
      if (name === "hasChangeMainResearcher") {
        this.form.changeMainResearcher = "";
        this.form.hasChangeMainResearcher = val;
      }
      if (name === "hasChangeResearcherProperty") {
        this.form.changeResearcherProperty = "";
        this.form.hasChangeResearcherProperty = val;
      }
      if (name === "hasConcern") {
        this.form.concern = "";
        this.form.hasConcern = val;
      }
      if (name === "hasInformationFromCommittee") {
        this.form.informationFromCommittee = "";
        this.form.hasInformationFromCommittee = val;
      }
    },
    onUpload(e) {
      this.$store
        .dispatch("Common/uploadPdf", { form: "rf03", file: e })
        .then((res) => {
          this.form.agencyBook = res.fileName;
        })
        .catch((error) => {
          console.log(error);
        });
      this.form.agencyBook = e;
    },
    onClickBtn() {
      document.getElementById("agencyBook").click();
    },
  },
};
</script>

<style lang="scss">
label.v-label.theme--light {
  color: #544a44;
}
.color-label-checkbox {
  label.v-label.theme--light {
    color: #3e7662;
  }
}
.textAlignVer {
  -moz-transform-origin: 0 50%;
  -moz-transform: rotate(-90deg) translate(-50%, 50%);
  -webkit-transform-origin: 0 50%;
  -webkit-transform: rotate(-90deg) translate(-50%, 50%);
  -o-transform-origin: 0 50%;
  -o-transform: rotate(-90deg) translate(-50%, 50%);
  -ms-transform-origin: 0 50%;
  -ms-transform: rotate(-90deg) translate(-50%, 50%);
  transform-origin: 0 50%;
  transform: rotate(-90deg) translate(-50%, 50%);
  position: absolute;
  top: 0;
  bottom: 0;
  height: 2em; /* line-height of .wrapper div:first-child span */
  margin: auto;
  font-weight: bold;
  font-size: 1em;
  line-height: 2em; /* Copy to other locations */
  left: 15px;
}
</style>
